import React, { useEffect, useState, useTransition } from "react";
import moment from "moment";
import { useParams, Link, Outlet } from "react-router-dom";
import useApi from "../../hooks/useApi";
import usePagination from "../../hooks/usePagination";
import { FilterBar } from "../../widgets";
import useSortableTableHeader from "../../hooks/useSortableTableHeader";
import Button from "react-bootstrap/Button";
import useApp from "../../hooks/useApp";
import useReload from "../../hooks/useReload";

const RequirementListHeader = (props) => {
  return (
    <section id="content" className="content">
      <div className="content__header content__boxed">
        <div className="content__wrap">
          {/* <!-- Breadcrumb --> */}
          <nav aria-label="breadcrumb">
            <ol className="breadcrumb mb-0">
              <li className="breadcrumb-item">
                <Link to="/desktop">Home</Link>
              </li>
              <li className="breadcrumb-item">
                <Link to="#">Policies</Link>
              </li>
              <li className="breadcrumb-item">
                <Link to="/policy-requirements">Requirements</Link>
              </li>
              <li className="breadcrumb-item active" aria-current="page">
                List
              </li>
            </ol>
          </nav>
          {/* <!-- END : Breadcrumb --> */}

          <h1 className="page-title mb-0 mt-2">Requirements List</h1>

          <p className="lead">List of Requirements for policies</p>

          <div className="d-md-flex align-items-baseline my-3">
            <Link to="./add" className="btn btn-info hstack gap-2 mb-3">
              <i className="demo-psi-add fs-4"></i>
              <span className="vr"></span>
              Add new
            </Link>

            <FilterBar />
          </div>
        </div>
      </div>
      <div className="content__boxed">
        <div className="content__wrap">{props.children}</div>
      </div>
    </section>
  );
};

const RequirementListMain = (props) => {
  const { api, abortSignal, auth } = useApi();
  const [requirements, setRequirements] = useState([]);
  const { id } = useParams();
  const { showAlert } = useApp();
  const { toggleReload, reload } = useReload();

  const { TableHeader } = useSortableTableHeader();

  const { Paginate, searchParamString } = usePagination();

  useEffect(() => {
    const callApi = async () => {
      try {
        const { data } = await api.list(
          `/policies/requirements/${searchParamString}`
        );
        setRequirements(data);
      } catch (error) {
        console.error(error);
      }
    };
    callApi();

    const abortApiCall = () => abortSignal && abortSignal.abort;
    return abortApiCall;
  }, [searchParamString, auth, reload]);

  const deleteRequirement = async (requirementId) => {
    try {
      const response = await api.delete(
        `/policies/requirements/${requirementId}`
      );
      if (response.ok) {
        showAlert("Requirement deleted", "success");
        toggleReload();
      }
    } catch (error) {
      console.error(error);
    }
  };

  const headers = [
    { label: "Name", sort: true },
    { label: "Identifier", sort: true },
    { label: "Type", sort: true },
    { label: "Options" },
    { label: "Actions" },
  ];

  return (
    <>
      {!props?.headless && (
        <>
          <h2 className="mb-0 mt-2">Products</h2>
          <div className="d-md-flex align-items-baseline my-3">
            <Link to="add" className="btn btn-info hstack gap-2 mb-3">
              <i className="demo-psi-add fs-4"></i>
              <span className="vr"></span>
              Add new
            </Link>
          </div>
        </>
      )}
      <div className="table-responsive bg-white">
        <table className="table table-striped">
          <TableHeader items={headers} />
          <tbody>
            {requirements &&
              requirements?.map((requirement) => (
                <tr key={requirement.id}>
                  <td>
                    <Link to={`${requirement.id}/edit`} className="btn-link">
                      {requirement?.name || ""}
                    </Link>
                  </td>
                  <td className="">{requirement?.identifier || ""}</td>
                  <td>
                    <span className="text-muted">
                      <span className="p-end-2">{requirement?.type || ""}</span>
                    </span>
                  </td>
                  <td className="">
                    <pre className="text-break">
                      {requirement?.options || ""}
                    </pre>
                  </td>
                  <td className="">
                    <Button
                      variant="danger"
                      title="Delete record"
                      onClick={() => deleteRequirement(requirement?.id)}
                      className="btn-icon"
                    >
                      <i className="bi bi-trash-fill fs-5"></i>
                    </Button>
                  </td>
                </tr>
              ))}
          </tbody>
        </table>
        <Paginate />
      </div>
    </>
  );
};

const RequirementList = (props) => {
  return props?.scope ? (
    <RequirementListMain />
  ) : (
    <RequirementListHeader>
      <RequirementListMain headless={true} />
    </RequirementListHeader>
  );
};

export default RequirementList;
